import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {incidentsReducer} from './incidents.reducer';
import {EffectsModule} from '@ngrx/effects';
import {IncidentsEffects} from './incidents.effects';
import {incidentsFeatureKey} from './incidents.actions';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(incidentsFeatureKey, incidentsReducer),
    EffectsModule.forFeature([IncidentsEffects])
  ]
})
export class IncidentsStoreModule {

}
